import { Link } from 'react-router'
import foto454 from '../assets/foto-clientgesprek-454.webp'
import foto908 from '../assets/foto-clientgesprek-908.webp'
import fotoTerugval from '../assets/foto-clientgesprek-908.jpg'
import { VinkItem } from '../components/Iconen'

/*
 * P3 — Over ons. Tekst en opbouw letterlijk uit legacy/current/over-ons.html
 * (CR-05).
 */
export default function OverOns() {
  return (
    <>
      <div className="page-head">
        <div className="wrap reveal">
          <span className="eyebrow">Over ons</span>
          <h1>Specialist in GPK-beoordelingen</h1>
          <p className="lede">
            Bij GPKeuringen richten wij ons volledig op medische beoordelingen
            voor gehandicaptenparkeerkaarten (GPK). Door onze volledige focus op
            dit vakgebied hebben wij een efficiënt proces ontwikkeld waarmee wij
            cliënten, gemeenten en samenwerkingspartners snel en deskundig
            kunnen ondersteunen.
          </p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: '40px' }}>
        <div className="wrap">
          <div className="prose reveal">
            <p>
              Onze artsen beschikken over ruime ervaring binnen zowel de
              klinische zorg als het sociaal-medische domein. Deze combinatie
              van medische expertise en kennis van relevante regelgeving stelt
              ons in staat om iedere aanvraag zorgvuldig, objectief en
              consistent te beoordelen.
            </p>
            <p>
              Wij geloven dat een medische beoordeling niet alleen deskundig
              moet zijn, maar ook toegankelijk, duidelijk en cliëntgericht.
              Daarom staan persoonlijke aandacht, heldere communicatie en korte
              doorlooptijden centraal in onze dienstverlening.
            </p>
            <div style={{ marginTop: '28px' }}>
              <Link to="/#aanvraag" className="btn btn--primary btn--big">
                Vraag aan
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--tint">
        <div className="wrap">
          <div className="reveal" style={{ maxWidth: '44em' }}>
            <span className="eyebrow">Onze werkwijze</span>
            <h2 style={{ fontSize: 'clamp(1.6rem,2.8vw,2.1rem)' }}>
              Een betrouwbare beoordeling begint bij een zorgvuldig proces
            </h2>
            <p className="lede" style={{ marginTop: '14px' }}>
              Daarom werken wij volgens duidelijke richtlijnen en een
              gestandaardiseerde beoordelingsmethode.
            </p>
          </div>
          <ul
            className="crit__list checks--2 reveal"
            style={{ marginTop: '32px' }}
          >
            <VinkItem>
              Objectieve en onafhankelijke medische beoordelingen
            </VinkItem>
            <VinkItem>
              Consistente advisering volgens geldende richtlijnen
            </VinkItem>
            <VinkItem>Korte wachttijden tot de beoordeling</VinkItem>
            <VinkItem>
              Adviezen die doorgaans binnen 24 uur worden verwerkt na het
              onderzoek
            </VinkItem>
            <VinkItem>Direct contact met onze artsen wanneer nodig</VinkItem>
            <VinkItem>
              Continue evaluatie en verbetering van onze dienstverlening
            </VinkItem>
          </ul>
          <p
            className="reveal"
            style={{
              marginTop: '26px',
              color: 'var(--muted)',
              maxWidth: '44em',
            }}
          >
            Door onze gespecialiseerde aanpak kunnen wij efficiënt werken zonder
            concessies te doen aan de kwaliteit van onze beoordelingen.
          </p>
        </div>
      </section>

      <section className="section">
        <div
          className="wrap"
          id="clientGrid"
          style={{
            display: 'grid',
            gridTemplateColumns: '0.9fr 1.1fr',
            gap: 'clamp(28px,5vw,64px)',
            alignItems: 'center',
          }}
        >
          <div className="reveal">
            <figure style={{ margin: 0 }}>
              {/*
                De bron is een PNG van 788 KB — een foto in een formaat dat voor
                foto's niets comprimeert. Als WebP is dat 26 KB bij dezelfde
                afmeting. Dat scheelt op mobiel 4G ruim een seconde, en NFR-04
                geeft de hele pagina er 2,5.

                De JPEG is de terugval voor browsers zonder WebP-ondersteuning
                (iOS onder 14). Die halen alleen de JPEG op, moderne browsers
                alleen de WebP. Het origineel staat nog in legacy/current.
              */}
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${foto454} 454w, ${foto908} 908w`}
                  sizes="(max-width: 960px) min(92vw, 520px), 45vw"
                />
                <img
                  alt="foto van een cliëntgesprek"
                  loading="lazy"
                  src={fotoTerugval}
                  width={908}
                  height={952}
                  style={{
                    width: '100%',
                    height: 'auto',
                    aspectRatio: '4/4.2',
                    objectFit: 'cover',
                    borderRadius: '18px',
                    display: 'block',
                  }}
                />
              </picture>
            </figure>
          </div>
          <div>
            <div className="reveal" style={{ maxWidth: '40em' }}>
              <span className="eyebrow">Cliëntgericht en toegankelijk</span>
              <h2 style={{ fontSize: 'clamp(1.6rem,2.8vw,2.1rem)' }}>
                Weten waar u aan toe bent, van begin tot eind
              </h2>
              <p className="lede" style={{ marginTop: '14px' }}>
                Wij begrijpen dat een aanvraag voor een
                gehandicaptenparkeerkaart vaak onderdeel is van een situatie
                waarin mobiliteit en zelfstandigheid een belangrijke rol spelen.
                Daarom streven wij naar een dienstverlening die laagdrempelig,
                vriendelijk en duidelijk is.
              </p>
            </div>
            <ul className="crit__list reveal" style={{ marginTop: '26px' }}>
              <VinkItem>Een professionele en persoonlijke benadering</VinkItem>
              <VinkItem>Afspraakbevestigingen binnen een week</VinkItem>
              <VinkItem>
                Tijdige herinneringen voorafgaand aan afspraken
              </VinkItem>
              <VinkItem>
                Flexibele beoordelingsmogelijkheden op locatie, via videobellen
                of aan huis
              </VinkItem>
              <VinkItem>
                Directe toelichting op het medische advies en de uitkomst van de
                beoordeling
              </VinkItem>
              <VinkItem>
                Geen kosten bij annulering 24 uur voor de afspraak
              </VinkItem>
            </ul>
            <p
              className="reveal"
              style={{ marginTop: '22px', color: 'var(--muted)' }}
            >
              Wij vinden het belangrijk dat cliënten weten waar zij aan toe zijn
              en zich gehoord voelen gedurende het gehele traject.
            </p>
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <div className="infoband reveal">
            <h2>Samenwerking met gemeenten en organisaties</h2>
            <p>
              GPKeuringen werkt graag samen met gemeenten,
              uitvoeringsorganisaties en andere betrokken partijen. Wij hechten
              waarde aan duurzame samenwerkingen gebaseerd op kwaliteit,
              betrouwbaarheid en transparante communicatie.
            </p>
            <p>
              Heeft u vragen over onze dienstverlening of wilt u kennismaken?
              Dan gaan wij graag vrijblijvend met u in gesprek. Ook wanneer er
              op dit moment nog geen directe mogelijkheden zijn voor
              samenwerking, denken wij graag mee over toekomstige kansen.
            </p>
            <div style={{ marginTop: '22px' }}>
              <Link to="/contact" className="btn btn--coral">
                Neem contact op
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
